import { createFileRoute } from "@tanstack/react-router";

import { CustomersListPage } from "@/modules/customers/pages/CustomersList.page";

export const Route = createFileRoute("/__authed/m/customers/")({
	component: CustomersListPage,
});
